export const COLUMN_COLOR = {
  Pink: '#E83E8C',
  Blue: '#007BFF',
  Brown: '#8B4513',
  Green: '#218838',
  Yellow: '#FFC107',
  Orange: '#FD7E14',
  Purple: '#6F42C1',
  Red: '#DC3545',
  DarkGreen: '#005F73',
};
